import React from 'react';
import { Star } from 'lucide-react';

const AboutSection = ({ sectionRef, translations }) => {
  const t = translations;

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-br from-pink-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              {t.aboutTitle}
            </h2>
            <h3 className="text-2xl text-pink-600 mb-6">{t.aboutSubtitle}</h3>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              {t.aboutText}
            </p>
            <div className="flex items-center space-x-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" />
              ))}
              <span className="text-gray-600 ml-2">5+ Years Experience</span>
            </div>
          </div>
          <div className="relative">
            <div className="w-80 h-80 bg-gradient-to-br from-pink-300 to-purple-300 rounded-full flex items-center justify-center mx-auto overflow-hidden">
              <img 
                src="/nina_photo.jpg" 
                alt="Nina" 
                className="w-full h-full object-cover rounded-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;